import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { CarrinhoProvider } from '../../providers/carrinho/carrinho';
import { ViewProvider } from '../../providers/view/view';
import { DadosProvider } from '../../providers/dados/dados';
import { PagamentoPedidoFormPage } from '../pagamento-pedido-form/pagamento-pedido-form';
import { ProdutoListPage } from '../produto-list/produto-list';
import { AcessoexternoProvider } from '../../providers/acessoexterno/acessoexterno';

@Component({
  selector: 'page-pedido-form',
  templateUrl: 'pedido-form.html',
})
export class PedidoFormPage {

  totalPedido:number;

  //ITENS DO  PEDIDO
  itens:Array<any>;
  
  taxaEntrega:any;

  endereco:any;

  
  constructor(public navCtrl: NavController, public navParams: NavParams, public server: SemovelProvider, 
    public carrinho:CarrinhoProvider, public view:ViewProvider, public dados:DadosProvider,
    private acessoProvider:AcessoexternoProvider) {
    
    this.taxaEntrega = dados.getTaxaEntrega();
    this.endereco = dados.endereco;
    
    this.carrinho.eve.subscribe("carrinho:atualizar_itens", (itens) => {
      this.itens = itens;
    });

    this.carrinho.eve.subscribe("carrinho:atualizar_total", (valor_total) => {
      this.totalPedido = valor_total;
    });
  
  }

  ionViewDidLoad() {
    this.itens = this.carrinho.getItens();
    this.totalPedido = this.carrinho.total;
  }
  
  ionViewDidEnter(){
  }

  contato(){
    this.acessoProvider.entrarEmContato();
  }
  confirmarPedido(event){
    
    if(!this.carrinho.validar_pedido()){
      this.view.showError(this.carrinho.visualizar_erros());
      return;
    }

    this.navCtrl.push(PagamentoPedidoFormPage);
  }

  diminuir_item(item){
    this.carrinho.diminuirItem(item);
  }
  
  aumentar_item(item){
    this.carrinho.aumentarItem(item);
  }

  removerItem(item, index){
    this.view.showConfirm("Deseja remover o item?", () => {
      this.carrinho.removerItem(item, index);
    });
  }

  visualizar_item(item){
    
  }

  informarVoucher(){
      this.view.showInput("Voucher", "Informe o código do voucher.", (value) => {
        this.validarVoucher(value.informacao);
      });
  }

  validarVoucher(codigoVoucher:string){
    console.log(codigoVoucher);
    if(!codigoVoucher || !codigoVoucher.length || codigoVoucher.length == 0 ){
      this.view.showMessage("Código não informado."+codigoVoucher);
      return;
    }
    
    
    this.server.postData({method:"buscar_voucher"}, {codigo:codigoVoucher}).subscribe(
      (voucher) => {
        this.carrinho.aplicarVoucher(voucher);
      },
      (erro) =>{
        this.view.showMessage("Não foi possível validar o voucher. "+erro);
      }
    );
  }

  cancelar(){
    this.view.showConfirm("Deseja cancelar o pedido atual?", () => {
        this.carrinho.limpar_pedido();
    });
  }
  abrirTelaProdutos(){
    this.navCtrl.setRoot(ProdutoListPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/pedido-form/pedido-form.ts